/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeSchematicLicenseDeletedDto,
  ApiEnvelopeSchematicLicenseDto,
  ApiEnvelopeSchematicLicenseListDto,
  CreateSchematicLicenseRequest,
  UpdateSchematicLicenseRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type schematicLicenseAdminListEntriesResponse200 = {
  data: ApiEnvelopeSchematicLicenseListDto
  status: 200
}

export type schematicLicenseAdminListEntriesResponseSuccess = (schematicLicenseAdminListEntriesResponse200) & {
  headers: Headers;
};
;

export type schematicLicenseAdminListEntriesResponse = (schematicLicenseAdminListEntriesResponseSuccess)

export const getSchematicLicenseAdminListEntriesUrl = () => {




  return `/api/admin/schematic-licenses/entries`
}

export const useSchematicLicenseAdminListEntriesHook = (): ( options?: RequestInit) => Promise<schematicLicenseAdminListEntriesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getSchematicLicenseAdminListEntriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type schematicLicenseAdminCreateEntryResponse200 = {
  data: ApiEnvelopeSchematicLicenseDto
  status: 200
}

export type schematicLicenseAdminCreateEntryResponse400 = {
  data: ApiEnvelopeSchematicLicenseDto
  status: 400
}

export type schematicLicenseAdminCreateEntryResponseSuccess = (schematicLicenseAdminCreateEntryResponse200) & {
  headers: Headers;
};
export type schematicLicenseAdminCreateEntryResponseError = (schematicLicenseAdminCreateEntryResponse400) & {
  headers: Headers;
};

export type schematicLicenseAdminCreateEntryResponse = (schematicLicenseAdminCreateEntryResponseSuccess | schematicLicenseAdminCreateEntryResponseError)

export const getSchematicLicenseAdminCreateEntryUrl = () => {




  return `/api/admin/schematic-licenses/entries`
}

export const useSchematicLicenseAdminCreateEntryHook = (): (createSchematicLicenseRequest?: CreateSchematicLicenseRequest, options?: RequestInit) => Promise<schematicLicenseAdminCreateEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (createSchematicLicenseRequest?: CreateSchematicLicenseRequest, options?: RequestInit) => {

        return customFetcher(getSchematicLicenseAdminCreateEntryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSchematicLicenseRequest)
  }
);
      }
  }


export type schematicLicenseAdminUpdateEntryResponse200 = {
  data: ApiEnvelopeSchematicLicenseDto
  status: 200
}

export type schematicLicenseAdminUpdateEntryResponse404 = {
  data: ApiEnvelopeSchematicLicenseDto
  status: 404
}

export type schematicLicenseAdminUpdateEntryResponseSuccess = (schematicLicenseAdminUpdateEntryResponse200) & {
  headers: Headers;
};
export type schematicLicenseAdminUpdateEntryResponseError = (schematicLicenseAdminUpdateEntryResponse404) & {
  headers: Headers;
};

export type schematicLicenseAdminUpdateEntryResponse = (schematicLicenseAdminUpdateEntryResponseSuccess | schematicLicenseAdminUpdateEntryResponseError)

export const getSchematicLicenseAdminUpdateEntryUrl = (id: string,) => {




  return `/api/admin/schematic-licenses/entries/${id}`
}

export const useSchematicLicenseAdminUpdateEntryHook = (): (id: string,
    updateSchematicLicenseRequest?: UpdateSchematicLicenseRequest, options?: RequestInit) => Promise<schematicLicenseAdminUpdateEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    updateSchematicLicenseRequest?: UpdateSchematicLicenseRequest, options?: RequestInit) => {

        return customFetcher(getSchematicLicenseAdminUpdateEntryUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSchematicLicenseRequest)
  }
);
      }
  }


export type schematicLicenseAdminDeleteEntryResponse200 = {
  data: ApiEnvelopeSchematicLicenseDeletedDto
  status: 200
}

export type schematicLicenseAdminDeleteEntryResponse404 = {
  data: ApiEnvelopeSchematicLicenseDeletedDto
  status: 404
}

export type schematicLicenseAdminDeleteEntryResponseSuccess = (schematicLicenseAdminDeleteEntryResponse200) & {
  headers: Headers;
};
export type schematicLicenseAdminDeleteEntryResponseError = (schematicLicenseAdminDeleteEntryResponse404) & {
  headers: Headers;
};

export type schematicLicenseAdminDeleteEntryResponse = (schematicLicenseAdminDeleteEntryResponseSuccess | schematicLicenseAdminDeleteEntryResponseError)

export const getSchematicLicenseAdminDeleteEntryUrl = (id: string,) => {




  return `/api/admin/schematic-licenses/entries/${id}`
}

export const useSchematicLicenseAdminDeleteEntryHook = (): (id: string, options?: RequestInit) => Promise<schematicLicenseAdminDeleteEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getSchematicLicenseAdminDeleteEntryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


